import Image from "next/image";
import Link from "next/link";

function TagBadge({ label, light = false }) {
  return (
    <span
      className={`rounded-md px-2 py-1 text-[0.65rem] font-medium ${
        light ? "bg-white/12 text-white/82" : "bg-[#f3f1ec] text-zinc-500"
      }`}
    >
      {label}
    </span>
  );
}

function ArticleMeta({ item, light = false }) {
  return (
    <div
      className={`flex flex-wrap items-center gap-3 ${
        light ? "text-white/76" : "text-[#06040c]/54"
      }`}
    >
      {(item.tags || []).map((tag) => (
        <TagBadge key={`${item.id}-${tag}`} label={tag} light={light} />
      ))}
      <p
        className={`font-raleway text-sm tracking-tight leading-none sm:text-sm ${
          light ? "text-white/76" : "text-[#06040c]/54"
        }`}
      >
        {item.date}
      </p>
    </div>
  );
}

export default function NewsGridCard({
  item,
  className = "",
  titleClassName = "",
}) {
  return (
    <Link
      href={`/news/${item.slug ?? item.id}`}
      className={`group block scroll-mt-36 focus-visible:outline-none ${className}`}
    >
      <article className="overflow-hidden rounded-md bg-white transition-transform duration-300 ">
        <div className="relative overflow-hidden rounded-t-md">
          <div className={`absolute inset-0 ${item.frameClassName}`} />
          <div className="relative aspect-[1.62/1] overflow-hidden rounded-t-md bg-primary">
            <Image
              src={item.image}
              alt={item.title}
              fill
              className="
      object-cover
      brightness-90
      saturate-90
      contrast-110
      sepia-[0.0]
      hue-rotate-[-10deg]
      transition-transform
      duration-500
      group-hover:scale-[1.03]
    "
              style={{ objectPosition: item.imagePosition }}
              sizes="(min-width: 1280px) 22vw, (min-width: 768px) 42vw, 100vw"
            />

            {}
            <div
              className="
      absolute inset-0
      bg-[#ffcc88]/30
      mix-blend-color
      pointer-events-none
    "
            />
          </div>
        </div>

        <div className="space-y-4 p-5 sm:p-6">
          {}

          <div className="flex flex-col justify-between space-y-3">
            <h3
              className={`font-raleway text-[1.8rem] font-semibold leading-[1.02] tracking-[-0.05em] text-[#06040c] sm:text-[1.6rem] line-clamp-3 z-20 ${titleClassName}`}
            >
              {item.title}
            </h3>
            <p className="max-w-md text-[0.92rem] leading-5 text-zinc-600 line-clamp-3">
              {item.description}
            </p>
          </div>
        </div>
      </article>
    </Link>
  );
}
